import React, { useEffect } from "react";
import { useField } from "formik";
import SntCheckBox from "@/cleanup/components/SntCheckBox/SntCheckBox";

interface InputCheckProps {
  name: string;
  label?: React.ReactNode;
  handleChange?: (value: boolean) => void;
  disabled?: boolean;
  className?: string;
  title?: string;
}

const InputCheck: React.FC<InputCheckProps> = ({
  name,
  label,
  handleChange,
  disabled,
  className,
  title,
}) => {
  const [field, , helper] = useField(name);

  useEffect(() => {
    handleChange?.(field.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.value]);

  const onChange = (value: boolean): void => {
    helper.setValue(value);
  };

  return (
    <SntCheckBox
      checked={field.value}
      onChange={onChange}
      label={label}
      disabled={disabled}
      title={title}
    />
  );
};

export default InputCheck;